<template>
  <div id="_line" style="position: relative">
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Link Copied') }}!</v-snackbar
    >
    <v-container>
      <v-layout>
        <v-flex>
          <h1 class="title">Line Chatbot</h1>
        </v-flex>

        <v-flex>
          <div class="text-xs-right">
            <v-btn
              v-if="!isEditLine && $store.getters.getPackage == 'premium'"
              icon
              outline
              color="primary"
              @click="isEditLine = true"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <div style="position: relative; padding-top: 15px; padding-bottom: 15px">
        <v-premium-plan-popup
          v-if="$store.getters.getPackage != 'premium'"
          :show-all="false"
          margin-top="65"
          style="border-radius: 10px"
        ></v-premium-plan-popup>
        <ul class="list-group vertical-steps">
          <li class="list-group-item">
            <div class="form-control">
              <label for>Webhook Url</label>
              <div class="row" style="margin-bottom: 0">
                <div class="col s12 m9">
                  <textarea
                    ref="shareLink"
                    v-model="webhookUrl"
                    class="form-control"
                    style="resize: vertical; min-height: 90px; background: #eee"
                    onclick="this.select()"
                    readonly="true"
                  ></textarea>
                </div>
                <div class="text-xs-left col s12 m3">
                  <v-btn
                    v-clipboard:copy="webhookUrl"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    style="position: relative"
                    outline
                    color="primary"
                  >
                    <span class="fas fa-copy mr-1"></span>
                    {{ $t('copy') }}
                    <transition
                      enter-active-class="animated fadeInUp"
                      leave-active-class="animated fadeOut"
                    ></transition>
                  </v-btn>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="form-control">
              <label for="text">{{ $t('Access Token') }}</label>
              <div v-if="isEditLine">
                <textarea
                  v-model="line.line_access_token"
                  class="form-control"
                  rows="5"
                  maxlength="600"
                  style="resize: vertical; min-height: 90px"
                  :placeholder="'Access Token'"
                ></textarea>
              </div>
              <div v-else>
                <div class="primary--text" style="word-break: break-all">
                  {{ line.line_access_token ? line.line_access_token : '-' }}
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="form-control">
              <label for="text">{{ $t('Channel Secret') }}</label>
              <div v-if="isEditLine">
                <textarea
                  v-model="line.line_channel_secret"
                  class="form-control"
                  rows="5"
                  maxlength="600"
                  style="resize: vertical; min-height: 90px"
                  :placeholder="'Channel Secret'"
                ></textarea>
              </div>
              <div v-else>
                <div class="primary--text" style="word-break: break-all">
                  {{ line.line_channel_secret ? line.line_channel_secret : '-' }}
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="form-control">
              <label for="text">{{ $t('Channel ID') }}</label>
              <div v-if="isEditLine">
                <textarea
                  v-model="line.line_channel_id"
                  class="form-control"
                  rows="5"
                  maxlength="600"
                  style="resize: vertical; min-height: 90px"
                  :placeholder="'Channel ID'"
                ></textarea>
              </div>
              <div v-else>
                <div class="primary--text" style="word-break: break-all">
                  {{ line.line_channel_id ? line.line_channel_id : '-' }}
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div v-if="isEditLine" class="text-xs-center" style="margin-top: 15px">
          <v-btn outline color="grey" @click="cancelEditLine">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="saveEditLine">{{ $t('Save') }}</v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      line: {
        line_access_token: null,
        line_channel_secret: null,
        line_channel_id: null
      },
      isEditLine: false,
      showCopy: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    webhookUrl: function () {
      return config.webhookUrl + 'webhookline?facebookpageid=' + this.selectedBot.pageid
    }
  },
  async mounted() {
    const vm = this

    vm.$store.dispatch('loading')
    await vm.getLineToken()
    vm.cached_line = JSON.stringify(vm.line)
    if (!vm.line.line_access_token || !vm.line.line_channel_secret) {
      vm.isEditLine = true
    }
  },
  methods: {
    getLineToken: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineToken({ pageid: vm.selectedBot.pageid }, function (error, response) {
          vm.$store.dispatch('clear_loading')
          if (error) {
            reject(error)
          }
          vm.line = {
            line_access_token: response.data.line_access_token,
            line_channel_secret: response.data.line_channel_secret,
            line_channel_id: response.data.line_channel_id
          }
          resolve()
        })
      })
    },
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {},
    onCopyError: function () {},
    cancelEditLine: function () {
      var vm = this
      vm.line = vm.cached_line ? JSON.parse(vm.cached_line) : ''
      vm.isEditLine = false
    },
    saveEditLine: function () {
      var vm = this
      if (vm.$store.getters.getPackage !== 'premium') {
        vm.line = JSON.parse(vm.cached_line)
        vm.isEditLine = false
        return
      }
      vm.$store.dispatch('loading')
      api.saveLineToken(
        {
          pageid: vm.selectedBot.pageid,
          line_access_token: vm.line.line_access_token ? vm.line.line_access_token.trim() : '',
          line_channel_secret: vm.line.line_channel_secret
            ? vm.line.line_channel_secret.trim()
            : '',
          line_channel_id: vm.line.line_channel_id ? vm.line.line_channel_id.trim() : ''
        },
        function (error) {
          if (error) {
            vm.$store.dispatch('loading')
          }
          vm.cached_line = JSON.stringify(vm.line)
          vm.isEditLine = false
          vm.$store.dispatch('loading')
          location.reload()
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/ConnectLineTraditional.vue